module.exports = __webpack_public_path__ + "static/media/andrea.bb841b2b.jpg";